export interface OrderAgent {
  id: string;
  salesOrderHeaderId: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  supplierSingleLineAddress: string;
  supplierMultiLineAddress: string;
  rate: number;
  rateIsAmount: boolean;
  rateIsAmountYesNo: string;
}
